var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form",
    {
      staticClass: "mt-4 flex flex-col justify-start",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.handleSearch.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "flex mb-4" }, [
        _c(
          "div",
          {
            staticClass:
              "relative rounded-md shadow-sm border flex items-center w-full px-3 bg-white",
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.keyword,
                  expression: "keyword",
                },
              ],
              staticClass: "w-full",
              attrs: { id: "name", placeholder: _vm.placeholder, type: "text" },
              domProps: { value: _vm.keyword },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.keyword = $event.target.value
                },
              },
            }),
          ]
        ),
        _c(
          "div",
          { staticClass: "flex md:mt-0 ml-4" },
          [
            _c("ui-button", {
              attrs: {
                variant: "outline",
                type: "submit",
                buttonText: "Search",
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }